// Shared types for the "Requests to Add" (entity add request / approval) feature — OPE-5037.

// PostHog feature flag gating the entire "Requests to Add" surface — the requestNewSuppliers access
// permission toggle, the admin tab, and the Suppliers-page request toolbar.
export const REQUEST_TO_ADD_ENTITIES_FEATURE_FLAG = 'request_to_add_entities_enabled';

export const ENTITY_REQUEST_ENTITY_TYPES = {
	supplier: 'supplier',
	asset: 'asset',
	part: 'part',
};

export const ENTITY_ADD_REQUEST_STATUSES = {
	draft: 'draft',
	pending_review: 'pending_review',
	approved: 'approved',
	rejected: 'rejected',
};

// Requests are editable / submittable only in these states; approvable / rejectable only in pending_review.
export const EDITABLE_ENTITY_ADD_REQUEST_STATUSES = [
	ENTITY_ADD_REQUEST_STATUSES.draft,
	ENTITY_ADD_REQUEST_STATUSES.rejected,
];

export const ENTITY_REQUEST_ANSWER_TYPES = {
	short_text: 'short_text',
	long_text: 'long_text',
	multiple_choice: 'multiple_choice',
	yes_no: 'yes_no',
	number: 'number',
	date: 'date',
};

export const ENTITY_REQUEST_ANSWER_TYPE_DISPLAY_NAMES = {
	[ENTITY_REQUEST_ANSWER_TYPES.short_text]: 'Short Text',
	[ENTITY_REQUEST_ANSWER_TYPES.long_text]: 'Long Text',
	[ENTITY_REQUEST_ANSWER_TYPES.multiple_choice]: 'Multiple Choice',
	[ENTITY_REQUEST_ANSWER_TYPES.yes_no]: 'Yes / No',
	[ENTITY_REQUEST_ANSWER_TYPES.number]: 'Number',
	[ENTITY_REQUEST_ANSWER_TYPES.date]: 'Date',
};

export interface SupplierRequestPayload {
	companyName: string;
	contactEmail: string;
	contactFirstName: string;
	contactLastName: string;
	problemTypeIds: number[];
	allProblemTypes: boolean;
	locationIds: number[];
	allLocations: boolean;
}

export interface EntityRequestQuestion {
	questionText: string;
	answerType: string;
	required: boolean;
	options: string[];
	orderingId: number;
}

export interface EntityRequestAnswer {
	question: EntityRequestQuestion;
	answer: any;
	orderingId: number;
}

export interface EntityRequestForm {
	id?: number;
	buyerCompanyId?: number;
	entityType: string;
	isActive: boolean;
	questions: EntityRequestQuestion[];
}

export interface EntityAddRequest {
	id?: number;
	buyerCompanyId?: number;
	entityType: string;
	status?: string;
	displayName?: string;
	requestedByEmail?: string;
	// Hydrated sibling contacts of the *ByEmail fields, populated by the API on read. Typed `any`
	// to match the app-wide convention for contact objects (see getContactName / UserName).
	requestedByContact?: any;
	approvedByEmail?: string;
	approvedByContact?: any;
	rejectedByEmail?: string;
	rejectedByContact?: any;
	payload: SupplierRequestPayload | any;
	answers: EntityRequestAnswer[];
	rejectionReason?: string;
	createdEntityType?: string;
	createdEntityId?: number;
	createdAt?: string;
	updatedAt?: string;
}

export interface EntityAddRequestAudit {
	id: number;
	buyerCompanyId: number;
	entityAddRequestId: number;
	entityType: string;
	auditType: string;
	fromStatus: string;
	toStatus: string;
	note: string;
	createdBy: string;
	// Hydrated sibling contact of createdBy, populated by the API on read.
	createdByContact?: any;
	createdAt: string;
}
